import { render, staticRenderFns } from "./RejectedOriginalDocuments.vue?vue&type=template&id=7b7e5244&scoped=true"
import script from "./RejectedOriginalDocuments.vue?vue&type=script&lang=js"
export * from "./RejectedOriginalDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7e5244",
  null
  
)

export default component.exports